"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidatedRequiredServices = getValidatedRequiredServices;
/**
 * Validates that all @see {requiredServices} are present in the @see {allServiceUrls}. Throws an error otherwise.
 * @param allServiceUrls All available services with URLs
 * @param requiredServices Names of services that must be present in the @see {allServiceUrls} dataset
 * @returns All services passed in @see {allServiceUrls}
 */
function getValidatedRequiredServices(allServiceUrls, requiredServices) {
  const missingServices = requiredServices.filter(serviceName => !allServiceUrls[serviceName]);
  if (missingServices.length > 0) {
    throw new Error(`Following required services '${missingServices.join(', ')}' were not found in Configuration Manager!`);
  }
  return allServiceUrls;
}
